module.exports = __webpack_public_path__ + "img/840.6f0ca0d8.svg";